// import { MetaType } from "@/types/meta";
import { BoardStore } from "@noli/business";
import { SingleNode } from "@noli/core";

// 获取图片节点在画板上展示的宽高
export const getNodeDisplayWH = (alias?: string) => {
  if (!alias) return { w: 0, h: 0 };
  const bgNode = BoardStore.graph.getExistingNode<SingleNode>(alias);
  if (!bgNode) {
    return { w: 0, h: 0 };
  }
  const bgBBox = bgNode.bbox;
  const bounding = bgBBox.bounding.toAABB();
  const { w, h } = bounding.wh;
  return { w: Number(w.toFixed(2)), h: Number(h.toFixed(2)) };
};

// 获取图片原文件宽高
export const getNodeFileWH = (alias?: string) => {
  if (!alias) return { w: 0, h: 0 };
  const bgNode = BoardStore.graph.getExistingNode<SingleNode>(alias);
  if (!bgNode) {
    return { w: 0, h: 0 };
  }
  const bgBBox = bgNode.bbox;
  const bounding = bgBBox.bounding.toAABB();
  const { w, h } = bounding.wh;
  return { w: Number(w.toFixed(2)), h: Number(h.toFixed(2)) };
};

// type GenerateWHMetaType = Exclude<MetaType["type"], "upload" | "duplicate" | "landscape">;

export const getSuitableWH = (alias: string, maxWH: number) => {
  const fileWH = getNodeFileWH(alias);
  const displayWH = getNodeDisplayWH(alias);
  if (fileWH.w * fileWH.h > maxWH ** 2) {
    if (displayWH.w * displayWH.h < fileWH.w * fileWH.h) {
      return {
        w: displayWH.w,
        h: Math.abs(displayWH.h),
      };
    }
  }
  return fileWH;
};
